import { render, staticRenderFns } from "./PorPendencias.vue?vue&type=template&id=39904817"
import script from "./PorPendencias.vue?vue&type=script&lang=js"
export * from "./PorPendencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports